<footer class="site-footer">
  <div class="footer-container footer-grid">
    <div class="footer-about">
      <a routerLink="/" class="footer-logo-link" aria-label="DotBlack home">
        <img src="/assets/img/dotBlackLogo-removebg-preview.png" alt="DotBlack" class="footer-logo" />
      </a>
      <p><strong>DotBlack Projex</strong> provides integrated services in <em>IT consulting, intelligent automation and RPA, programme and project management, IT resource augmentation and digital solutions.</em></p>
    </div>

    <div class="footer-column">
      <h3>Quick Links</h3>
      <ul>
        <li><a routerLink="/">Home</a></li>
        <li><a routerLink="/about-us">About us</a></li>
        <li class="footer-solutions-group">
          <span class="footer-solutions-label">Digital Solutions</span>
          <a routerLink="/digital-solutions" class="footer-solution-link">MUF-K.Integrated</a>
        </li>
        <li><a routerLink="/it-consulting">IT Consulting</a></li>
        <li><a routerLink="/rpa">Automation &amp; RPA</a></li>
        <li><a routerLink="/project-management">Programme Delivery</a></li>
        <li><a routerLink="/it-services">IT Resource Augmentation</a></li>
      </ul>
    </div>

    <div class="footer-column hours-column">
      <h3>Operating Hours</h3>
      <p><strong>Monday - Friday</strong><br>08:30 - 16:30</p>
      <p><strong>Saturday - Sunday</strong><br>Closed</p>
    </div>

    <div class="footer-column footer-contact-info">
      <h3>Contact Us</h3>
      <p>Office 0005, Jardown 1<br>377 Johannes Ramokhoase Street<br>Pretoria Central, 0002</p>
      <a href="tel:+27115685421">+27 11 568 5421</a>
      <a href="mailto:mufk@dotblack.co.za">mufk@dotblack.co.za</a>
    </div>
  </div>

  <div class="copyright">
    <div class="footer-container copyright-inner">
      <span>© {{ currentYear }} DotBlack Projex Pty (Ltd). All rights reserved.</span>
      <nav class="legal-links" aria-label="Legal and support links">
        <a routerLink="/popia">POPIA</a>
        <a routerLink="/privacy-notice">Privacy Notice</a>
        <a routerLink="/cookie-notice">Cookie Notice</a>
        <button type="button" class="cookie-settings-link" (click)="openCookieSettings()">Cookie Settings</button>
        <a routerLink="/accessibility-statement">Accessibility Statement</a>
      </nav>
    </div>
  </div>
</footer>
